
export default {

    methods: {

        dialogHeadingClasses () {
            let self = this

            return {
                'text-truncate': 1,
                'pl-4': 1,
                // 'display-1': self.$vuetify.breakpoint.mdAndUp,
                'text-h5': self.$vuetify.breakpoint.mdAndUp,
                'text-h6': self.$vuetify.breakpoint.smAndDown,
                'darken-2': self.isDark
            }
        },

        closeDialog (dialogName){
            let self = this;
            self[dialogName] = false;
        }

    }

}
